import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { FruitifySchoolClassSearch } from "./FruitifySchoolClassSearch";

export const SchoolClassSelectDialog = ({
  open,
  setOpen,
  onSelect,
  quiz = false,
  renderAlternativeAction,
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  const handleSelect = (s) => {
    onSelect(s);
    handleClose();
  };
  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Select class</DialogTitle>
      <DialogContent>
        <Typography>
          Select one class for now, you can link the{" "}
          {quiz ? "quiz" : "assignment"} to more later
        </Typography>
        <FruitifySchoolClassSearch
          listView
          onSelect={handleSelect}
          showToggle={false}
        />
        {renderAlternativeAction && (
          <Stack spacing={1} alignItems="center" sx={{ mt: 2 }}>
            <Typography color="text.secondary">or</Typography>
            {renderAlternativeAction(handleClose)}
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={handleClose} variant="contained">
            Cancel
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
